import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BranchDetail from './components/BranchDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageBranch',
  components: {
    BranchDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;